import React, { useEffect, useState } from "react";
import systemListingService from "./SystemListingServices";
import Pagination from "components/Common/newPagination";
import FormatCodeUpsert from "./upsert/FormatCodeUpsert";

export default function FormatCode(param: any) {
  const [query, setQuery] = useState("");
  const [showDims, setShowDims] = useState(false);
  let [editDawer, setEditDawer] = useState<any>(false);
  const [editingOn, setEditingOn] = useState<boolean>(false);
  const [editDataDawer, setEditDataDawer] = useState<any>([]);
  const [activeTab, setActiveTab] = useState<any>("Recorded Music");
  let [formatCodeListing, SetFormatCodeListing] = useState<any>([]);
  let [tempformatCodeListing, SetTempFormatCodeListing] = useState<any>([]);
  let [formatCount, setFormatCount] = useState<number>(0);

  useEffect(() => {

    if (param.activeTab === "Format / Source Codes") {
      formatCodeSelect("Recorded Music")
    }
  }, [param])

  const formatCodeSelect = (formatCode: any) => {
    setActiveTab(formatCode)
    console.log(formatCode)

    formatCount = 0
    setFormatCount(formatCount)

    const payload = {
      filter: formatCode === "Recorded Music" ? "sales" : "publishing",
    };

    systemListingService.getAllFormatCodeByParentGroup(payload).then((respond) => {
      SetTempFormatCodeListing(respond);
      formatCodeListing = respond.slice((1 - 1) * 10, (10 * 1));
      SetFormatCodeListing(formatCodeListing)
      formatCount = respond.length;
      setFormatCount(formatCount);

    });
  };

  const openAddDrawer = (code: any) => {
    if (code) {
      setEditDataDawer(code)
    }
    editDawer = true
    setEditDawer(editDawer);
    console.log(editDawer)

  };

  const closeDrawer = () => {
    editDawer = false
    setEditDawer(editDawer);
    console.log(editDawer)
  };

  const openEditDrawer = (row: any) => {
    if (row) {
      setEditDataDawer(row)
    }
    editDawer = true
    setEditDawer(editDawer);
    console.log(editDawer)

  };

  const onPageChange = (payLoad: any) => {
    console.log(payLoad)

    formatCodeListing = tempformatCodeListing.slice((payLoad.pageNumber - 1) * payLoad.pageSize, payLoad.pageSize * payLoad.pageNumber);
    SetFormatCodeListing(formatCodeListing)
  }

  return (
    <div>

      <div className="content-card ws-12">
        {/* Header */}
        <div className="card-header-row ws-12">
          <div className="card-title">Format / Source Codes</div>
          <div className="card-header-actions">
            <span className="pt mt">
              {formatCount} record(s) found
            </span>
            <button className="icon-btn info" id="editModeBtn" type="button" onClick={() => setEditingOn((prev) => !prev)}>
              {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}
            </button>
          </div>
        </div>

        {/* Filter */}
        <div className="filter-row ws-12" style={{ padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb" }} >
          <div className="filter-input-row" style={{ alignItems: "flex-end", display: "flex", width: "100%", }}                >
            <div className="filter-inline">
              <div className="filter-label">Filter</div>
              <div className="filter-input-group">
                <input
                  className="form-input"
                  placeholder="Search by code, format, parent group…"
                  value={query}
                  onChange={(e) => { setQuery(e.target.value); }}
                />
                <button className="icon-btn primary" type="button">
                  Search
                </button>
              </div>
            </div>

            {/* DIM Columns toggle */}
            <div className="filter-inline" style={{ alignItems: "flex-end", marginLeft: "auto" }} >
              <div className="filter-label">DIM Columns</div>
              <div className="ac-toggle">
                <span style={{ fontSize: 13, color: "#374151" }}>
                  {showDims ? "Shown" : "Hidden"}
                </span>
                <div
                  className={"pp-switch" + (showDims ? " on" : "")}
                  onClick={() => setShowDims((prev) => !prev)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      setShowDims((p) => !p);
                  }}
                  style={{ cursor: "pointer" }}
                  aria-pressed={showDims}
                  title="Toggle DIM columns"
                >
                  <div className="pp-knob" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="category-tabs-row ws-12">
          <div className="category-tabs">
            <button className={"category-tab" + (activeTab === "Recorded Music" ? " active" : "")} onClick={() => { setActiveTab("Recorded Music"); formatCodeSelect("Recorded Music"); }}>
              Recorded Music
            </button>
            <button className={"category-tab" + (activeTab === "Publishing" ? " active" : "")} onClick={() => { setActiveTab("Publishing"); formatCodeSelect("Publishing"); }}>
              Publishing
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="allowHscroll ws-12">
          {formatCount > 0 && <table className={editingOn ? "editing-on newTable" : "newTable"}>
            <thead>
              <tr className="forceSingleLine">
                <th >Code</th>
                {!showDims && <th >Format/Source Code</th>}
                {!showDims && <th >Part Format</th>}
                {!showDims && <th >Mechanicals</th>}
                {!showDims && <th >Cat Format</th>}
                {!showDims && <th >Cat Format Code</th>}
                {!showDims && <th >Parent Group</th>}
                {!showDims && <th >Format Report</th>}
                {!showDims && <th >Esc Rate Album</th>}
                {!showDims && <th >Esc Rate Track</th>}
                {!showDims && <th >Operation</th>}

                {showDims && <th >Code</th>}
                {showDims && <th >DIM1</th>}
                {showDims && <th >DIM2</th>}
                {showDims && <th >DIM3</th>}
              </tr>
            </thead>

            <tbody>
              {formatCodeListing.map((r: any) => (
                <tr key={r.code ?? r.codingStr}>

                  <td >{r.codingStr}</td>
                  {!showDims && <td >{r.formatDesc}</td>}
                  {!showDims && <td >{r.partFormat}</td>}
                  {!showDims && <td >{r.mechanicals}</td>}
                  {!showDims && <td >{r.royaltyFormat}</td>}
                  {!showDims && <td >{r.digital}</td>}
                  {!showDims && <td >{r.releaseDesc}</td>}
                  {!showDims && <td >{r.formatReport}</td>}
                  {!showDims && <td >{r.escRateAlbum}</td>}
                  {!showDims && <td >{r.escRateTrack}</td>}

                  {showDims && <td >{r.analysisDim1}</td>}
                  {showDims && <td >{r.analysisDim2}</td>}
                  {showDims && <td >{r.analysisDim3}</td>}

                  <td style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }} >

                    <div style={{ width: '90px', whiteSpace: 'nowrap' }}>
                      <button className="icon-btn edit" title="Edit" type="button" disabled={!editingOn} onClick={() => openEditDrawer(r)}>
                        <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M12 20h9" />
                          <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
                        </svg>
                      </button>

                      <button className="icon-btn delete" title="Delete" type="button" disabled={!editingOn} >
                        <i className="icon-trash"> </i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}


            </tbody>
          </table>}

          {formatCount === 0 && <div className="ws-12">
            <div className="alert alert-info ws-12 box" >No records to display</div>
          </div>}
        </div>

        {/* Export row */}
        <div className="pagination-export-row ws-12" style={{ marginTop: 12, paddingTop: 8, }}>
          <div className="ws-2 pull-right" style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8, }}>
            <div className="card-header-actions">
              <button className="btn btn-ghost" type="button">
                <strong>Export</strong>
              </button>
            </div>
          </div>

          {formatCount > 10 && <div className="ws-10">
            <Pagination totalRow={formatCount} onPageChange={onPageChange} />
          </div>}
        </div>

        {/* Add button */}
        <div className="add-row-wrapper ws-12" style={{ marginTop: 12, display: "flex", justifyContent: "flex-start", }} >
          <button className="btn-add-row" type="button" disabled={!editingOn} onClick={openAddDrawer}>
            + Add Format Codes
          </button>
        </div>

      </div>

      {(() => {

        if (editDawer === true) {

          return <FormatCodeUpsert editDawer={editDawer} editDataDawer={editDataDawer} closeDrawer={closeDrawer} />
        }

      })()}

    </div>
  );
};